import { FormControl, MenuItem, Select } from "@mui/material";
import { OutreachContactsContext } from "contexts/OutreachContacts";
import { useContext } from "react";
import { CustomEvent } from "schemas/functions";

import styles from "./styles";

export default function StarredSelect() {
  const { fetchContactsParams, handleFetchContacts } = useContext(
    OutreachContactsContext,
  );

  const handleChange = (e: CustomEvent) => {
    const updatedParams = { ...fetchContactsParams };
    updatedParams.page = 1;
    updatedParams.importantOnly = !updatedParams.importantOnly;
    handleFetchContacts(updatedParams);
  };

  return (
    <FormControl variant="outlined" size="small">
      <Select
        name="filter"
        sx={styles.filter}
        onChange={handleChange}
        value={fetchContactsParams.importantOnly ? "Needs Response" : "All"}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Needs Response">Needs Response</MenuItem>
      </Select>
    </FormControl>
  );
}
